export default __webpack_public_path__ + "media/images/submit-centre-45478d55a8ba3bc608b4e0217e2dae49.png";